export default __webpack_public_path__ + "static/media/sold_desktop.20ec5a55.png";